import { defaultGet } from '@4beefopag/4bee-fopag-core/dist/services';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import moment from 'moment';
import { apiClient } from '../util/http';

export const getRequisicoes = async (params) => {
  if (params.folha && params.competencia && params.tipo) {
    const { data } = await apiClient.get('/payroll/by-competence', { params });
    return data;
  }
  return [];
};

export const getColaboradores = async (params) => {
  if (params.idApontamento) {
    return defaultGet(params, '/apontamento/colaboradores');
  }
  return { total: 0, colaboradores: [] };
};

export const converterObjetoCalculo = (tipo, calculos) => {
  if (!calculos) {
    return {};
  }

  if (tipo === 'A') {
    return calculos.reduce((r, calculo) => {
      // eslint-disable-next-line no-param-reassign
      r[calculo.contratado] = {
        horistaMensalista: calculo.horistaMensalista,
        variavel: calculo.variavel,
        ajudaCusto: calculo.ajudaCusto,
        reembolso: calculo.reembolso,
        adiantamento: calculo.adiantamento,
        houveAlteracaoAjCusto: calculo.houveAlteracaoAjCusto,
      };
      return r;
    }, {});
  }

  if (tipo === 'M') {
    return calculos.reduce((r, calculo) => {
      // eslint-disable-next-line no-param-reassign
      r[calculo.contratado] = {
        horistaMensalista: calculo.horistaMensalista,
        diasTrabalhados: calculo.diasTrabalhados,
        baseHora: calculo.baseHora,
        hourlyRate: calculo.hourlyRate,
        producao: calculo.producao,
        variavel: calculo.variavel,
        ajudaCusto: calculo.ajudaCusto,
        reembolso: calculo.reembolso,
        totalRendimentos: calculo.totalRendimentos,
        descontosDiversos: calculo.descontosDiversos,
        adiantamento: calculo.adiantamento,
        totalDebitos: calculo.totalDebitos,
        liquido: calculo.liquido,
      };
      return r;
    }, {});
  }

  return {};
};

export const APONTAMENTO = {
  horistaMensalista: {
    horista: 1,
    mensalista: 2,
  },
  situacoes: {
    admitido: 1,
    demitido: [2, 3],
    ferias: 9,
  },
  tiposRequisicoes: {
    mensal: 'M',
    adiantamento: 'A',
  },
  status: {
    rascunho: 0,
    enviada: 1,
    reabertura_pendente: 2,
    reabertura_efetivada: 3,
    reabertura_cancelada: 4,
    cancelado: 5,
    processada: 6,
    faturada: 7,
    transmitida: 8,
    pago: 9,
    transmitindo: 10,
  },
  camposReducer: {
    monthlyEstimate: 0,
    hourlyRate: 1,
  },
};

export const PAYROLL_ACTOR_KIND = {
  PORTAL: 'portal',
  M2M: 'm2m',
};

export const importarFile = async ({ arquivo, idRequisicao, campos, validarCampos, sheetIndex }) => {
  const formData = new FormData();
  formData.append('file', arquivo);

  // Sempre envia campos como JSON string no body do FormData
  // Se campos é array válido, converte para JSON; caso contrário, envia array vazio
  const camposArray = Array.isArray(campos) && campos.length > 0 ? campos : [];
  formData.append('fields', JSON.stringify(camposArray));
  formData.append('sheetIndex', sheetIndex);
  formData.append('ignoreValidation', !validarCampos);

  return apiClient.post(`/payroll/${idRequisicao}/import`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

/**
 * gravar valor hora para o colaborador no portal
 * @param {number} requisicao
 * @param {number} contratado
 * @param {number} hourlyRate
 * @param {number} monthlyEstimate
 * @return {Promise<void>}
 */
export const gravarValorCadastro = async (requisicao, contratado, hourlyRate, monthlyEstimate, horistaMensalista) =>
  apiClient.post(`/payroll/${requisicao}/cooperators/${contratado}/remuneration`, {
    valuePerHour: hourlyRate,
    baseSalary: monthlyEstimate,
    incomeCalculationType: horistaMensalista,
  });

/**
 * calcula totais para um campo do apontamento
 * @param calculos
 * @param {string} chave
 * @return {string}
 */
export const calculaTotal = (items, chave) => {
  const valor = items.reduce((prev, item) => prev + (item[chave] || 0), 0.0);
  return moneyFormat(valor);
};

/**
 * calcula total geral da tela do apontamento de produção
 * converte valor em string para um número
 * @param totais
 * @return {string}
 */
export const totalGeral = (totais) => {
  const valor = Object.keys(totais).reduce((accumulator, key) => {
    const TOTAL_KEYS = ['variavel', 'reembolso', 'adiantamento'];
    if (TOTAL_KEYS.includes(key)) {
      const valorSemPontos = totais[key].replace(/\D/g, '');
      const valorCampo = valorSemPontos / 100;

      return accumulator + valorCampo;
    }

    return accumulator;
  }, 0.0);

  return moneyFormat(valor);
};

export const buscarParametrizacaoFolha = async (idFolha, vigencia) => {
  if (idFolha !== null && idFolha !== undefined && vigencia !== null && vigencia !== undefined) {
    const competency = moment(vigencia).format('YYYY-MM');
    const { data } = await apiClient.get(`/payroll-parameter/company/${idFolha}/competency/${competency}`);
    return data ?? {};
  }

  return {};
};
